import React from 'react';

interface UserTimeIconProps {
  className?: string;
}

const UserTimeIcon: React.FC<UserTimeIconProps> = ({ className = "w-6 h-6" }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="currentColor"
    >
      <path d="m8.474 11a5.5 5.5 0 1 1 5.5-5.5 5.506 5.506 0 0 1 -5.5 5.5zm8.526-1a7 7 0 1 0 7 7 7.008 7.008 0 0 0 -7-7zm2 10.414-3-3v-4.414h2v3.586l2.414 2.414zm-11-3.414a8.938 8.938 0 0 1 .947-4h-3.947a5.006 5.006 0 0 0 -5 5v6h11.349a8.98 8.98 0 0 1 -3.349-7z"/>
    </svg>
  );
};

export default UserTimeIcon;
